import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            minWidth: 130,
            minHeight: 50
        },
    }),
);

const IconWrapper = (props: any) => {
    return (
        <span style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "white", borderRadius: 50, marginLeft: 5 }}>
            <NavigateNextIcon style={{ color: "#0049a3" }} />
        </span>
    );
}

const NextButton = ({ setActiveStep, onClick, finalStep }: any) => {
    const classes = useStyles();

    const handleNext = async (): Promise<void> => {
        const validate = await onClick();
        if (validate == false || finalStep) return;
        setActiveStep((prevActiveStep: any) => prevActiveStep + 1);
    };
    return (
        <Button className={classes.button} variant="contained" color="primary" endIcon={<IconWrapper />} onClick={handleNext}>
            {finalStep ? "Submit" : "Next"}
        </Button>
    )
}

export default NextButton;